import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { VariableDetails } from '../../shared/ontology/model/variable-details';
import { VariableService } from '../../shared/ontology/service/variable.service';
import { TranslateService } from '@ngx-translate/core';
import { VariableDetailsContext } from './variable-details.context';
import { AlertService } from '../../shared/alert/alert.service';

@Component({
    selector: 'jhi-variable-details',
    templateUrl: './variable-details.component.html'
})
export class VariableDetailsComponent implements OnInit {

    variableId: number;
    title: string;
    isModal: boolean;

    constructor(private activeModal: NgbActiveModal,
                private variableService: VariableService,
                private route: ActivatedRoute,
                private translateService: TranslateService,
                private alertService: AlertService,
                private variableDetailsContext: VariableDetailsContext) {

        this.route.queryParams.subscribe((value) => {
            this.variableId = value.variableId;
        });

        this.isModal = this.route.snapshot.queryParamMap.has('modal');
    }

    ngOnInit(): void {
        (<any>window).onCloseModal = this.dismiss;

        this.variableService.getVariableById(this.variableId).subscribe(
            (res: VariableDetails) => this.onSuccess(res)
        );
    }

    private onSuccess(variableDetails: VariableDetails) {
        this.title = this.translateService.instant('ontology.variable-details.title',
            { param: variableDetails.name });
        this.variableDetailsContext.variableDetails.next(variableDetails);
    }

    dismiss() {
        this.activeModal.dismiss();
        if ((<any>window.parent).closeModal) {
            (<any>window.parent).closeModal();
        }
    }

}
